import { FetchFileAttachmentsSortTypes } from './fileAttachmentsTypes';

export const INITIAL_FILE_ATTACHMENTS_FILTERS = {};
export const INITIAL_FILE_ATTACHMENTS_PAGE = 1;
export const INITIAL_FILE_ATTACHMENTS_SORT = [
  FetchFileAttachmentsSortTypes.CREATED_AT_DESC
];
export const INITIAL_FILE_ATTACHMENTS_LIMIT = 50;

// Extensions of the attachments shown in the images folders instead of
// the files ones. Tiff is rendered via its generated png versions
export const IMAGE_FILE_ATTACHMENT_EXTENSIONS = [
  'png',
  'jpg',
  'jpeg',
  'bmp',
  'gif',
  'tif',
  'tiff'
];

export const enum FileAttachmentTypesEnum {
  ATTACHMENTS = 'attachments',
  DRAWING = 'drawing',
  FILES = 'files',
  IMAGES = 'images',
  LD = 'ld',
  LIFESTYLES = 'lifestyles',
  MATERIALS = 'materials',
  PRODUCTS = 'products',
  REFERENCE = 'reference',
  SOURCE_FILES = 'sourceFiles',
  TEXTURE = 'texture',
  THREED = 'threeD'
}

export const enum FileAttachmentsPermissions {
  READ_RESTORE_S3_OBJECTS_MODAL_SOURCE_FILES_ACCESSIBILITY_TEXT = 'read_restore_s3_objects_modal_source_files_accessibility_text',
  READ_DROPZONE_FILE_ATTACHMENT_LD_TAB = 'read_dropzone_file_attachment_ld_tab',
  READ_RESTORE_S3_OBJECTS_MODAL = 'read_restore_s3_objects_modal',
  READ_FILE_ATTACHMENT_DOWNLOAD_SEPARATELY_BUTTON = 'read_file_attachment_download_separately_button',
  READ_FILE_ATTACHMENT_TAGS = 'read_file_attachment_tags',
  READ_FILE_ATTACHMENT_EDIT_TAGS_BUTTON = 'read_file_attachment_edit_tags_button'
}
